const walletBalancePath = process.env.NEXT_PUBLIC_WALLET_BALANCE_PATH?.trim() || '/bff/orbit/v1/wallet/balance'
const walletTxnBasePath = process.env.NEXT_PUBLIC_WALLET_TXN_BASE_PATH?.trim() || '/bff/orbit/v1/wallet/txn'

export const isWalletBffPath = (path: string): boolean => path.startsWith('/bff/')

export const getWalletBalancePath = (): string => walletBalancePath

export const getWalletTransactionsPath = (userId: string | number): string =>
    `${walletTxnBasePath}/${userId}/transactions`
